import React, { Fragment } from "react";
import { useField } from "formik";
import {Currency} from "../../../app/models/currency";
import {observer} from "mobx-react-lite";

type SelectorProps = {
    options: Currency[];
    title: string;
    selected?: string;
    label: string;
    onChange:(code:string)=>void,
    disabled:boolean
};
const CurrencySelector = ({
                      name,
                      options,
                      title,
                      selected,
    disabled,
                      label,
    onChange,
                      ...props
                  }: SelectorProps|any) => {
    const [field, meta] = useField(name);
    return (
        <Fragment>
            <div className="mt-1 relative shadow-sm">
                <select
                    {...field}
                    {...props}
                    className={`rounded ${
                        meta.touched && meta.error
                            ? "mt-1 form-select rounded-none block w-full pl-3 pr-10 py-2 text-base leading-6 border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red sm:text-sm sm:leading-5"
                            : `mt-1 form-select rounded-none block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5 ${(disabled)?'bg-gray-200 cursor-not-allowed':''}`
                    }`}
                    disabled={disabled}

                    onChange={(e)=>onChange(e.target.value)}
                >
                    <option value="">{label}</option>
                    {options.map((item:Currency) => (
                        <option key={item.label} value={item.code}>
                            {`${item.name_plural} - (${item.code})`}
                        </option>
                    ))}
                </select>
                {meta.touched && meta.error ? (
                    <div className="absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none">
                        <svg
                            className="h-5 w-5 text-red-500"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                clip-rule="evenodd"
                            />
                        </svg>
                    </div>
                ) : (
                    ""
                )}
            </div>
            {meta.touched && meta.error ? (
                <p className="mt-2 text-sm text-red-600" id="email-error">
                    {meta.error}
                </p>
            ) : (
                ""
            )}
        </Fragment>
    );
};

export default CurrencySelector;
